import { Link } from 'react-router-dom';
import nebiLogo from '@/assets/images/nebi-branco.png';
import styles from './SiteFooter.module.scss';

/** Superfície sempre escura nos dois temas — daí os tokens `--nebi-footer-*`. */
export const SiteFooter = () => {
  const year = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.grid}>
        <div className={styles.brand}>
          <img src={nebiLogo} alt="NEBI" className={styles.logo} />
          <p className={styles.blurb}>
            Núcleo de Ensino Bíblico da Primeira Igreja em Mogi das Cruzes. Aprender, crescer e
            servir.
          </p>
          <p className={styles.address}>Rua Barão de Jaceguai, 1019 — Centro, Mogi das Cruzes/SP</p>
        </div>

        <nav aria-label="Rodapé" className={styles.column}>
          <div className={styles.label}>Navegação</div>
          <Link to="/home" className={styles.link}>
            Início
          </Link>
          <Link to="/cursos" className={styles.link}>
            Cursos
          </Link>
          <Link to="/conhecanos" className={styles.link}>
            Sobre o NEBI
          </Link>
        </nav>

        <nav aria-label="Conta" className={styles.column}>
          <div className={styles.label}>Sua conta</div>
          <Link to="/login" className={styles.link}>
            Entrar ou criar conta
          </Link>
          <Link to="/dashboard-aluno" className={styles.link}>
            Minha aprendizagem
          </Link>
          <Link to="/minhas-compras" className={styles.link}>
            Minhas compras
          </Link>
        </nav>

        <div className={styles.column}>
          <div className={styles.label}>Contato</div>
          <a
            href="https://wa.me/5511970953008"
            className={styles.link}
            target="_blank"
            rel="noreferrer"
          >
            WhatsApp (11) 97095-3008
          </a>
          <a href="tel:+551147266515" className={styles.link}>
            Telefone (11) 4726-6515
          </a>
          <a href="mailto:pibmogi@pibmogi.com.br" className={styles.link}>
            pibmogi@pibmogi.com.br
          </a>
          <a
            href="https://www.instagram.com/primeiraigrejamogi/"
            className={styles.link}
            target="_blank"
            rel="noreferrer"
          >
            Instagram
          </a>
          <a
            href="https://www.facebook.com/PibMogi/"
            className={styles.link}
            target="_blank"
            rel="noreferrer"
          >
            Facebook
          </a>
          <a
            href="https://www.youtube.com/c/Fam%C3%ADliaPIBMogi"
            className={styles.link}
            target="_blank"
            rel="noreferrer"
          >
            YouTube
          </a>
        </div>
      </div>

      <div className={styles.copyright}>
        © {year} NEBI · Núcleo de Ensino Bíblico — Primeira Igreja Mogi. Todos os direitos
        reservados.
      </div>
    </footer>
  );
};

export default SiteFooter;
